module.exports = __webpack_public_path__ + "assets/help/Help.6515258e.pdf";